var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "d-flex position-relative mb-3" }, [
    _c("a", {
      staticClass: "Card-link Card-link--secondary stretched-link",
      attrs: { href: `${_vm.link}` },
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "Post-image",
      style: `background-image: url('${_vm.post.imagePath}')`,
    }),
    _vm._v(" "),
    _c("div", { staticClass: "p-3 p-md-3 w-100 min-w-0" }, [
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-md-9" }, [
          _c("h2", { staticClass: "h5 Post-header mb-2 mb-lg-0" }, [
            _vm._v(_vm._s(_vm.post.title)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3 text-md-right" }, [
          _vm.post.date
            ? _c("p", { staticClass: "h5 font-size-sm" }, [
                _vm._v(_vm._s(_vm.$date(_vm.post.date).format("L"))),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "font-size-sm d-none d-md-block" }, [
        _vm._v(_vm._s(_vm._f("stringLimit")(_vm.post.description, 300))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-none d-xl-flex flex-column justify-content-center flex-shrink-0",
      },
      [
        _c("div", { staticClass: "Post-arrow" }, [
          _c("svg", { staticClass: "icon-small ml-2" }, [
            _c("use", { attrs: { "xlink:href": "#icon-chevron-right" } }),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }